export type ReachGoalParams = Record<string, unknown> | undefined;
type YM = (id: number, type: string, ...args: unknown[]) => void;

export function reachMetrikaGoal(goal: string) {
  if (typeof window === 'undefined') return;
  if (!goal) return;

  const ymId = Number(process.env.NEXT_PUBLIC_YM_ID);
  const ym = (window as unknown as { ym?: YM }).ym as YM | undefined;

  if (!ym || !Number.isFinite(ymId)) return;

  ym(ymId, 'reachGoal', goal);
}
